// eslint-disable-next-line import/prefer-default-export
export function applyByKey(key, state, reducer) {
  return {
    ...state,
    [key]: {
      ...state[key],
      ...reducer(state[key])
    }
  };
}
